export interface AuthUser {
  uid: string;
  email?: string | null;
  photoURL?: string;
  displayName?: string;
  fullName?: string;
  phoneNumber?: string;
  country?: string;
  isAdmin?: boolean;
  role?: string;
  countryCode?: string;
  isMobileVerified?: boolean;
  isEmailVerified?: boolean;
  userId?: string;
}
